import React from 'react';

import cx from 'classnames';

import styles from './index.module.scss';

export const UpgradeTooltipText = (): JSX.Element => {
  return <p className={styles.text}>
    This feature is available with an upgraded plan.<br />
    <a href="/settings/subscription/compare">
      Click here to upgrade your account
    </a>
    {' 🚀'}
  </p>;
};

export const LapsedTooltipText = (): JSX.Element => {
  return <p className={cx(styles.text, styles.centered)}>
    Your SightX subscription has lapsed.<br/>
    <a href="/settings/subscription/compare">
      Restart your subscription
    </a>
    &nbsp; 🚀 to access features.
  </p>;
};